var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-plug",style:(`border-radius: ${_vm.borderRadius}; width: ${_vm.width}px; minWidth: ${_vm.width}px;  height: ${_vm.height}px; font-size: ${_vm.letterSize}`)},[_vm._v("\n  "+_vm._s(_vm.letter)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }